import { DataItemType, FormControlType } from "../../../../form/schema";
import schema from "./schema";
import conduct from "./conduct";
import design from "./components/design.vue";
import pc from "../../../../form/src/common/components/form-staff-selector/pc/index.vue";
import mobile from "../../../../form/src/common/components/form-staff-selector/mobile/index.vue";
export const info = {
    title: "部门多选",
    title_i18n: "{\"zh\": \"人员多选\", \"en\": \"DepartmentMultiSelector\"}",
    type: "departmentMultiSelector",
    icon: "h-icon-all-department-multiple-",
    dataItemType: DataItemType.DeptMulti,
    formControllerType: FormControlType.DepartmentMultiSelector,
    group: "基础控件",
};
export default {
    info,
    schema,
    conduct,
    components: {
        design,
        pc,
        mobile
    },
};
